export const getJsonString = (partialJsonString) => {
    return (
        (partialJsonString[0] === "{" ? "" : "{") +
        partialJsonString +
        (partialJsonString[partialJsonString.length - 1] === "}" ? "" : "}")
    );
};
